import Add from './Add.js'
import AddCircled from './AddCircled.js'
import AddList from './AddList.js'
import AlignedTextCenter from './AlignedTextCenter.js'
import AlignedTextLeft from './AlignedTextLeft.js'
import AlignedTextRight from './AlignedTextRight.js'
import Archive from './Archive.js'
import ArrowDown from './ArrowDown.js'
import ArrowLeft from './ArrowLeft.js'
import ArrowOut from './ArrowOut.js'
import ArrowRight from './ArrowRight.js'
import ArrowUp from './ArrowUp.js'
import Article from './Article.js'
import Award from './Award.js'
import BackfacingArrowsDiagonal from './BackfacingArrowsDiagonal.js'
import Bag from './Bag.js'
import BarChart from './BarChart.js'
import Bell from './Bell.js'
import BellDot from './BellDot.js'
import BellOff from './BellOff.js'
import BoldText from './BoldText.js'
import Bookmark from './Bookmark.js'
import Boolean from './Boolean.js'
import Branch from './Branch.js'
import Bulb from './Bulb.js'
import Calendar from './Calendar.js'
import CalendarAdd from './CalendarAdd.js'
import CalendarGo from './CalendarGo.js'
import Call from './Call.js'
import Caption from './Caption.js'
import Card from './Card.js'
import CardGame from './CardGame.js'
import Chat from './Chat.js'
import CheckmarkCircled from './CheckmarkCircled.js'
import CheckmarkFilled from './CheckmarkFilled.js'
import CheckmarkNormal from './CheckmarkNormal.js'
import CheckmarkSmall from './CheckmarkSmall.js'
import CheckmarkTimed from './CheckmarkTimed.js'
import ChevronDown from './ChevronDown.js'
import ChevronLeft from './ChevronLeft.js'
import ChevronRight from './ChevronRight.js'
import ChevronUp from './ChevronUp.js'
import ChevronsFacingAway from './ChevronsFacingAway.js'
import ChevronsOpposing from './ChevronsOpposing.js'
import CircleDotted from './CircleDotted.js'
import CircleRegular from './CircleRegular.js'
import Close from './Close.js'
import CodeOff from './CodeOff.js'
import CodeOn from './CodeOn.js'
import Coins from './Coins.js'
import ColorPicker from './ColorPicker.js'
import ColumnChart from './ColumnChart.js'
import Columns from './Columns.js'
import Copy from './Copy.js'
import Crosswords from './Crosswords.js'
import CurvedArrowLeft from './CurvedArrowLeft.js'
import CurvedArrowRight from './CurvedArrowRight.js'
import Dark from './Dark.js'
import Dashboard from './Dashboard.js'
import Delete from './Delete.js'
import Dice from './Dice.js'
import DragHandleDots from './DragHandleDots.js'
import DragHandleLines from './DragHandleLines.js'
import Edit from './Edit.js'
import EditEntry from './EditEntry.js'
import EditMultiple from './EditMultiple.js'
import Embed from './Embed.js'
import EndedArrowDown from './EndedArrowDown.js'
import EndedArrowLeft from './EndedArrowLeft.js'
import EndedArrowRight from './EndedArrowRight.js'
import EndedArrowUp from './EndedArrowUp.js'
import Error from './Error.js'
import ErrorFilled from './ErrorFilled.js'
import External from './External.js'
import FilterOff from './FilterOff.js'
import FilterOn from './FilterOn.js'
import Flag from './Flag.js'
import Folder from './Folder.js'
import FolderFilled from './FolderFilled.js'
import FolderNew from './FolderNew.js'
import Follow from './Follow.js'
import Forward from './Forward.js'
import Forward10 from './Forward10.js'
import FullScreenOff from './FullScreenOff.js'
import FullScreenOn from './FullScreenOn.js'
import Gallery from './Gallery.js'
import Globe from './Globe.js'
import Grid from './Grid.js'
import Group from './Group.js'
import Hand from './Hand.js'
import Heart from './Heart.js'
import Help from './Help.js'
import Hide from './Hide.js'
import History from './History.js'
import Home from './Home.js'
import Id from './Id.js'
import Image from './Image.js'
import Info from './Info.js'
import Insight from './Insight.js'
import ItalicText from './ItalicText.js'
import Language from './Language.js'
import Laptop from './Laptop.js'
import Layers from './Layers.js'
import Light from './Light.js'
import LineChart from './LineChart.js'
import LinkOff from './LinkOff.js'
import LinkOn from './LinkOn.js'
import ListBulleted from './ListBulleted.js'
import ListCheck from './ListCheck.js'
import ListNumbered from './ListNumbered.js'
import Lock from './Lock.js'
import LogIn from './LogIn.js'
import LogOut from './LogOut.js'
import MailClosed from './MailClosed.js'
import MailOpened from './MailOpened.js'
import MergingArrows from './MergingArrows.js'
import MoreHorizontal from './MoreHorizontal.js'
import MoreVertical from './MoreVertical.js'
import Movie from './Movie.js'
import Multiselect from './Multiselect.js'
import Music from './Music.js'
import NextCircled from './NextCircled.js'
import Number from './Number.js'
import OpposingArrowsDiagonal from './OpposingArrowsDiagonal.js'
import OpposingArrowsHorizontal from './OpposingArrowsHorizontal.js'
import OpposingArrowsOffset from './OpposingArrowsOffset.js'
import OpposingArrowsVertical from './OpposingArrowsVertical.js'
import Page from './Page.js'
import PageFind from './PageFind.js'
import PageReady from './PageReady.js'
import Pause from './Pause.js'
import PauseCircled from './PauseCircled.js'
import Percentage from './Percentage.js'
import Phone from './Phone.js'
import Play from './Play.js'
import PlayCircled from './PlayCircled.js'
import Policy from './Policy.js'
import Preferences from './Preferences.js'
import QuoteOff from './QuoteOff.js'
import QuoteOn from './QuoteOn.js'
import Record from './Record.js'
import Reference from './Reference.js'
import Refresh from './Refresh.js'
import Remove from './Remove.js'
import RemoveCircled from './RemoveCircled.js'
import Repeat from './Repeat.js'
import Revert from './Revert.js'
import Revert10 from './Revert10.js'
import RichText from './RichText.js'
import Rows from './Rows.js'
import Search from './Search.js'
import Select from './Select.js'
import Settings from './Settings.js'
import Share from './Share.js'
import Sheet from './Sheet.js'
import Show from './Show.js'
import SidebarDocked from './SidebarDocked.js'
import SidebarFloating from './SidebarFloating.js'
import Sliders from './Sliders.js'
import SlotMachine from './SlotMachine.js'
import SortAscending from './SortAscending.js'
import SortDescending from './SortDescending.js'
import SortNormal from './SortNormal.js'
import SplitArrows from './SplitArrows.js'
import Stop from './Stop.js'
import StopCircled from './StopCircled.js'
import StrikethroughText from './StrikethroughText.js'
import String from './String.js'
import Sudoku from './Sudoku.js'
import TextStyling from './TextStyling.js'
import Time from './Time.js'
import TimeClose from './TimeClose.js'
import TimeEdit from './TimeEdit.js'
import TinyChevronDown from './TinyChevronDown.js'
import TinyChevronLeft from './TinyChevronLeft.js'
import TinyChevronRight from './TinyChevronRight.js'
import TinyChevronUp from './TinyChevronUp.js'
import TrendDown from './TrendDown.js'
import TrendFlat from './TrendFlat.js'
import TrendUp from './TrendUp.js'
import Trophy from './Trophy.js'
import UnderlinedText from './UnderlinedText.js'
import Updates from './Updates.js'
import User from './User.js'
import UserNew from './UserNew.js'
import UserSetting from './UserSetting.js'
import Users from './Users.js'
import Video from './Video.js'
import VolumeDown from './VolumeDown.js'
import VolumeOff from './VolumeOff.js'
import VolumeUp from './VolumeUp.js'
import Website from './Website.js'
import Websites from './Websites.js'

export default {
  add: Add,
  'add-circled': AddCircled,
  'add-list': AddList,
  'aligned-text-center': AlignedTextCenter,
  'aligned-text-left': AlignedTextLeft,
  'aligned-text-right': AlignedTextRight,
  archive: Archive,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-out': ArrowOut,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  article: Article,
  award: Award,
  'backfacing-arrows-diagonal': BackfacingArrowsDiagonal,
  bag: Bag,
  'bar-chart': BarChart,
  bell: Bell,
  'bell-dot': BellDot,
  'bell-off': BellOff,
  'bold-text': BoldText,
  bookmark: Bookmark,
  boolean: Boolean,
  branch: Branch,
  bulb: Bulb,
  calendar: Calendar,
  'calendar-add': CalendarAdd,
  'calendar-go': CalendarGo,
  call: Call,
  caption: Caption,
  card: Card,
  'card-game': CardGame,
  chat: Chat,
  'checkmark-circled': CheckmarkCircled,
  'checkmark-filled': CheckmarkFilled,
  'checkmark-normal': CheckmarkNormal,
  'checkmark-small': CheckmarkSmall,
  'checkmark-timed': CheckmarkTimed,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevrons-facing-away': ChevronsFacingAway,
  'chevrons-opposing': ChevronsOpposing,
  'circle-dotted': CircleDotted,
  'circle-regular': CircleRegular,
  close: Close,
  'code-off': CodeOff,
  'code-on': CodeOn,
  coins: Coins,
  'color-picker': ColorPicker,
  'column-chart': ColumnChart,
  columns: Columns,
  copy: Copy,
  crosswords: Crosswords,
  'curved-arrow-left': CurvedArrowLeft,
  'curved-arrow-right': CurvedArrowRight,
  dark: Dark,
  dashboard: Dashboard,
  delete: Delete,
  dice: Dice,
  'drag-handle-dots': DragHandleDots,
  'drag-handle-lines': DragHandleLines,
  edit: Edit,
  'edit-entry': EditEntry,
  'edit-multiple': EditMultiple,
  embed: Embed,
  'ended-arrow-down': EndedArrowDown,
  'ended-arrow-left': EndedArrowLeft,
  'ended-arrow-right': EndedArrowRight,
  'ended-arrow-up': EndedArrowUp,
  error: Error,
  'error-filled': ErrorFilled,
  external: External,
  'filter-off': FilterOff,
  'filter-on': FilterOn,
  flag: Flag,
  folder: Folder,
  'folder-filled': FolderFilled,
  'folder-new': FolderNew,
  follow: Follow,
  forward: Forward,
  'forward-10': Forward10,
  'full-screen-off': FullScreenOff,
  'full-screen-on': FullScreenOn,
  gallery: Gallery,
  globe: Globe,
  grid: Grid,
  group: Group,
  hand: Hand,
  heart: Heart,
  help: Help,
  hide: Hide,
  history: History,
  home: Home,
  id: Id,
  image: Image,
  info: Info,
  insight: Insight,
  'italic-text': ItalicText,
  language: Language,
  laptop: Laptop,
  layers: Layers,
  light: Light,
  'line-chart': LineChart,
  'link-off': LinkOff,
  'link-on': LinkOn,
  'list-bulleted': ListBulleted,
  'list-check': ListCheck,
  'list-numbered': ListNumbered,
  lock: Lock,
  'log-in': LogIn,
  'log-out': LogOut,
  'mail-closed': MailClosed,
  'mail-opened': MailOpened,
  'merging-arrows': MergingArrows,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  movie: Movie,
  multiselect: Multiselect,
  music: Music,
  'next-circled': NextCircled,
  number: Number,
  'opposing-arrows-diagonal': OpposingArrowsDiagonal,
  'opposing-arrows-horizontal': OpposingArrowsHorizontal,
  'opposing-arrows-offset': OpposingArrowsOffset,
  'opposing-arrows-vertical': OpposingArrowsVertical,
  page: Page,
  'page-find': PageFind,
  'page-ready': PageReady,
  pause: Pause,
  'pause-circled': PauseCircled,
  percentage: Percentage,
  phone: Phone,
  play: Play,
  'play-circled': PlayCircled,
  policy: Policy,
  preferences: Preferences,
  'quote-off': QuoteOff,
  'quote-on': QuoteOn,
  record: Record,
  reference: Reference,
  refresh: Refresh,
  remove: Remove,
  'remove-circled': RemoveCircled,
  repeat: Repeat,
  revert: Revert,
  'revert-10': Revert10,
  'rich-text': RichText,
  rows: Rows,
  search: Search,
  select: Select,
  settings: Settings,
  share: Share,
  sheet: Sheet,
  show: Show,
  'sidebar-docked': SidebarDocked,
  'sidebar-floating': SidebarFloating,
  sliders: Sliders,
  'slot-machine': SlotMachine,
  'sort-ascending': SortAscending,
  'sort-descending': SortDescending,
  'sort-normal': SortNormal,
  'split-arrows': SplitArrows,
  stop: Stop,
  'stop-circled': StopCircled,
  'strikethrough-text': StrikethroughText,
  string: String,
  sudoku: Sudoku,
  'text-styling': TextStyling,
  time: Time,
  'time-close': TimeClose,
  'time-edit': TimeEdit,
  'tiny-chevron-down': TinyChevronDown,
  'tiny-chevron-left': TinyChevronLeft,
  'tiny-chevron-right': TinyChevronRight,
  'tiny-chevron-up': TinyChevronUp,
  'trend-down': TrendDown,
  'trend-flat': TrendFlat,
  'trend-up': TrendUp,
  trophy: Trophy,
  'underlined-text': UnderlinedText,
  updates: Updates,
  user: User,
  'user-new': UserNew,
  'user-setting': UserSetting,
  users: Users,
  video: Video,
  'volume-down': VolumeDown,
  'volume-off': VolumeOff,
  'volume-up': VolumeUp,
  website: Website,
  websites: Websites,
} as const
